import type { SnakeCasedPropertiesDeep } from 'type-fest';
import { fetchForClient } from '~/infra/api/fetch-api';
import type { comment } from '~/infra/api/rpc';

type CommentIdRequest = SnakeCasedPropertiesDeep<comment.ICommentIdRequest>;
type CommentAddRequest = SnakeCasedPropertiesDeep<comment.ICommentAddRequest>;
type CommentReplyRequest =
  SnakeCasedPropertiesDeep<comment.ICommentReplyRequest>;

const SERVICE_PATH = '/comment.CommentService';

export const likeComment = async (commentId: string): Promise<void> => {
  const req: CommentIdRequest = {
    id: commentId,
  };
  await fetchForClient({
    path: `${SERVICE_PATH}/Like`,
    options: {
      body: JSON.stringify(req),
      method: 'POST',
    },
  });
};

export const unlikeComment = async (commentId: string): Promise<void> => {
  const req: CommentIdRequest = {
    id: commentId,
  };
  await fetchForClient({
    path: `${SERVICE_PATH}/Unlike`,
    options: {
      body: JSON.stringify(req),
      method: 'POST',
    },
  });
};

export const deleteComment = async (commentId: string): Promise<void> => {
  const req: CommentIdRequest = {
    id: commentId,
  };
  await fetchForClient({
    path: `${SERVICE_PATH}/Delete`,
    options: {
      body: JSON.stringify(req),
      method: 'POST',
    },
  });
};

export const addComment = async (request: CommentAddRequest): Promise<void> => {
  await fetchForClient({
    path: `${SERVICE_PATH}/AddV2`,
    options: {
      body: JSON.stringify(request),
      method: 'POST',
    },
  });
};

export const replyComment = async (
  request: CommentReplyRequest
): Promise<void> => {
  await fetchForClient({
    path: `${SERVICE_PATH}/ReplyV2`,
    options: {
      body: JSON.stringify(request),
      method: 'POST',
    },
  });
};
